import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { UserService } from '../services/user/user.service';
import { CommonService } from '../services/common/common.service';

@Injectable()
export class AuthLoginGuard implements CanActivate {
  constructor(private router: Router, private _user: UserService, private _common: CommonService) {
  }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this._user.checkSession().map((data: any) => {
      if (data) {
        localStorage.setItem('CURRENT_USER', JSON.stringify(data));
        this._common.storageChanged(data);
        return true;
      }
      this.router.navigate(['/landing']);
      // window.open('https://marketing.tractorzoom.com', '_self')
      return false;
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/guard/auth-login.guard.ts